export interface QuantityDto {
  value: number;
  unit: string;
}

export const quantityDto = (value: number, unit: string): QuantityDto => ({
  value,
  unit,
});

export interface NullableQuantityDto {
  value: number | null;
  unit: string;
}
